


































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import ProposalUserReport from "@/models/porposal/porposalUserReport.model";
import GenericEdit from "@/core/Generics/GenericEdit";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import fileService from "@/services/file.service";
import BudgetExpenseService from "@/services/budgetExpense.service";
import ProposalUserReportService from "@/services/proposalUserReport.service";
import ProposalBudgetItemExecution from "@/models/porposal/proposalBudgetItemExecution.model";
import ProposalBudgetSubItemExecution from "@/models/porposal/proposalBudgetSubItemExecution.model";
import { Utils } from "@/core/Utils";
import ProposalBudgetSubItemExecutionDocument from "../../models/porposal/proposalBudgetSubItemExecutionDocument.model";
import ProposalScheduleGanttPhase from "../../models/porposal/proposalScheduleGanttPhase.model";
import GantCharttComponent from "@/components/ganttChart/gantChartt.vue";
import { ProposalState } from "@/enums/ProposalState";
import EspecificObjective from '../../models/porposal/especificObjective.model';

@Component({
  components: {
    ResearchCenterBasicInformationComponent,
    DatePickerComponent,
    GantCharttComponent
  }
})
export default class CompleteReport extends GenericEdit<ProposalUserReport> {
  budgetExpenses = [];
  budgetExpenseService = new BudgetExpenseService();
  completeAndSend = false;
  files = [];
  proposalUserReportService: ProposalUserReportService = new ProposalUserReportService();
  proposalScheduleGanttPhases: Array<ProposalScheduleGanttPhase> = [];
  devueltoFC: ProposalState = ProposalState.DevueltoFC;
  matrizAnalitica: any = null;

  constructor() {
    super();
    this.controller = "PorposalUserReport";
    this.model = new ProposalUserReport();
  }

  onComplete() {}

  protected async getData() {
    
    try {
      this.loading = true;
      this.model = await this.repository.byId(this.id, this.include);
      console.log(this.model)
      if (
        this.model.state != ProposalState.EnviadoCI &&
        this.model.state != ProposalState.DevueltoFC
      ) {
        this.$router.push(`/recived-reports-ies`);
      }

      if (this.model.startPeriod)
        this.model.startPeriod = new Date(this.model.startPeriod);
      if (this.model.endPeriod)
        this.model.endPeriod = new Date(this.model.endPeriod);

      this.matrizAnalitica = await this.proposalUserReportService.getMatrizAnaliticaByProposalId(this.model.proposalId);
      let gantChart = await this.proposalUserReportService.getByEvaluacionType(
        this.model.proposalHistoricPercentDoneScheduleGanttId,
        this.model.proposalId
      );
      let lastGanttHistory = gantChart.proposalHistoricPercentDoneScheduleGantt;
      for (let i = 0; i < gantChart.proposalScheduleGanttPhases.length; i++) {
        const phase = lastGanttHistory.proposalHistoricPhasesPercentDone.find(
          x =>
            x.proposalScheduleGanttPhaseId ==
            gantChart.proposalScheduleGanttPhases[i].id
        );
        gantChart.proposalScheduleGanttPhases[i].percentDone =
          phase.percentDone;
        gantChart.proposalScheduleGanttPhases[i].percentDoneUI =
          phase.percentDone;
        for (
          let j = 0;
          j <
          gantChart.proposalScheduleGanttPhases[i]
            .proposalScheduleGanttActivities.length;
          j++
        ) {
          const activity = phase.proposalHistoricActivitiesPercentDone.find(
            x =>
              x.proposalScheduleGanttActivityId ==
              gantChart.proposalScheduleGanttPhases[i]
                .proposalScheduleGanttActivities[j].id
          );
          gantChart.proposalScheduleGanttPhases[
            i
          ].proposalScheduleGanttActivities[j].percentDone =
            activity.percentDone;
          gantChart.proposalScheduleGanttPhases[
            i
          ].proposalScheduleGanttActivities[j].percentDoneUI =
            activity.percentDone;
        }
      }
      this.proposalScheduleGanttPhases = gantChart.proposalScheduleGanttPhases;
      this.getBudgetExpenses();
      this.currentModelChange();
    } catch (errors) {
      
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  onCloseModal(row: any) {
    row.showExpectResult = false;
    this.$nextTick().then(() => {
      this.$forceUpdate();
    });
  }
  
  showExpectResultOnClic(row: any, index: number) {
    row.showExpectResult = true;
    this.$nextTick().then(() => {
      this.$forceUpdate();
    });
  }

  currentModelChange() {
    if (!this.model.proposalBudgetItemsExecution.length) {
      for (let i = 0; i < this.model.porposalBudgetItems.length; i++) {
        const porposalBudgetItem = this.model.porposalBudgetItems[i];
        var proposalBudgetItemExecution = new ProposalBudgetItemExecution();
        proposalBudgetItemExecution.porposalBudgetItemId =
          porposalBudgetItem.id;
        proposalBudgetItemExecution.porposalBudgetItem = porposalBudgetItem;

        for (
          let y = 0;
          y < porposalBudgetItem.porposalBudgetSubItems.length;
          y++
        ) {
          const subItem = porposalBudgetItem.porposalBudgetSubItems[y];
          var proposalBudgetSubItemExecution = new ProposalBudgetSubItemExecution();
          proposalBudgetSubItemExecution.porposalBudgetSubItemId = subItem.id;
          proposalBudgetSubItemExecution.porposalBudgetSubItem = subItem;
          proposalBudgetItemExecution.proposalBudgetSubItemsExecution.push(
            proposalBudgetSubItemExecution
          );
        }

        this.model.proposalBudgetItemsExecution.push(
          proposalBudgetItemExecution
        );
      }
    }
  }

  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then(response => {
      if (response) {
        this.budgetExpenses = response.filter(x =>
          this.model.porposalBudgetItems.some(y => y.budgetExpenseId == x.id)
        );
      }
    });
  }
  async verDocument(data: any = null) {
    if (data.isLastResport) {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
      //
      if (data.projectEndDocument.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.projectEndDocument.id,
          data.projectEndDocument.originalName
        );
      else await fileService.download(data.projectEndDocument.id);
    } else {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
    }
  }

  calculateTotalAmountSpentByBudgetExpense(
    rows: Array<ProposalBudgetItemExecution>
  ) {
    return rows.reduce((a, b) => {
      var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
        return c + d.amountSpent;
      }, 0);

      return a + result;
    }, 0);
  }
  calculateTotalSpentByBudgetItem(row: ProposalBudgetItemExecution) {
    return row.proposalBudgetSubItemsExecution.reduce((a, b) => {
      return a + b.amountSpent;
    }, 0);
  }

  get totalSpent() {
    return this.model.proposalBudgetItemsExecution.reduce((a, b) => {
      var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
        return c + d.amountSpent;
      }, 0);

      return a + result;
    }, 0);
  }

  cleanObject(sendObject: ProposalUserReport) {
    sendObject.document = null;
    sendObject.porposalBudgetItems = [];
    sendObject.proposal = null;
    sendObject.researchCenter = null;

    for (let i = 0; i < sendObject.proposalBudgetItemsExecution.length; i++) {
      const item = sendObject.proposalBudgetItemsExecution[i];
      item.porposalBudgetItem = null;
      for (let y = 0; y < item.proposalBudgetSubItemsExecution.length; y++) {
        const sub = item.proposalBudgetSubItemsExecution[y];
        sub.porposalBudgetSubItem = null;
      }
    }
  }

  async onChangeFiles(subItem: ProposalBudgetSubItemExecution) {
    if (subItem.files.length && subItem.files.some(x => x.size)) {
      this.loading = true;
      let docs = await fileService.uploadMany(subItem.files as File[]);

      docs.forEach(doc => {
        var newDoc = new ProposalBudgetSubItemExecutionDocument();
        newDoc.name = doc.originalName;
        newDoc.document = doc;
        subItem.proposalBudgetSubItemExecutionDocuments.push(newDoc);
      });
      this.loading = false;
      subItem.files = [];
    }
  }

  deleteFile(
    subItem: ProposalBudgetSubItemExecution,
    document: ProposalBudgetSubItemExecutionDocument
  ) {
    if (document.id) {
      document.deleted = true;
      document.document.deleted = true;
    } else {
      subItem.proposalBudgetSubItemExecutionDocuments = subItem.proposalBudgetSubItemExecutionDocuments.filter(
        x => x != document
      );
    }
  }

  async send() {
    var sendObject = Utils.mapToObject(
      this.model,
      new ProposalUserReport()
    ) as ProposalUserReport;
    this.cleanObject(sendObject);

    var result = await this.repository
      .update(this.id, sendObject)
      .finally(() => {
        this.getData();
      });
  }

  async saveData() {
    this.loading = true;
    await this.send();
    this.loading = false;
    this.operationSuccess();
  }

  protected async edit() {
    try {
      var valid = await this.$validator.validateAll();
      if (valid) {
        if (this.completeAndSend) {
          this.$buefy.dialog.confirm({
            title: "Confirmación",
            message: "¿Está seguro que desea enviar este reporte?",
            confirmText: "Adelante!",
            cancelText: "Cancelar",
            type: "is-danger",
            size: "is-medium",
            hasIcon: true,
            onConfirm: async () => {
              this.model.state = ProposalState.EnviadoFC;
              this.saveData();
            }
          });
        } else {
          this.saveData();
        }
      } else {
        this.operationFailedErrors(
          this.$validator.errors.items.map(e => e.msg)
        );
      }
    } catch (error) {
      var errors: any[] = [];
      if (Object.prototype.toString.call(error.data) === "[object String]") {
        errors.push(error.data);
      } else if (error.data && error.data.length > 0) {
        var errorMessages = error.data as any[];
        errorMessages.forEach(x => errors.push(x.errorMessage));
      } else {
        errors.push(error);
      }
      console.log(errors);
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
      this.completeAndSend = false;
    }
  }
}
